import { AfterViewInit, ChangeDetectorRef, Component } from "@angular/core";
import { BehaviorSubject, Observable } from "rxjs";
import { backgroundColors } from "./background-color";
import { Router } from "@angular/router";

@Component({
  selector: "app-card-resource",
  templateUrl: "./card-resource.component.html",
  styleUrls: ["./card-resource.component.scss"],
})
export class CardResourceComponent implements AfterViewInit {
  /**
   * Data da Asset Publisher.
   */
  data!: any;

  /**
   * BehaviorSubject per la lista di file.
   */
  _resourceList$ = new BehaviorSubject<any[]>([]);

  /**
   * Le props definite in fase di configurazione.
   */
  props: any;

  /**
   * Background colors list.
   */
  backgroundColors = backgroundColors;

  constructor(
    private cdr: ChangeDetectorRef,
    private router: Router
  ) { }
  /**
   * @inheritdoc
   */
  ngAfterViewInit(): void {
    if (this.data) {
      this.data.data = [...this.data.data];
      this.data.data.sort((a: any, b: any) =>
        a.entityTypeName.localeCompare(b.entityTypeName)
      );
      this._resourceList$.next([...this.data.data]);
      this.props = this.data.props;
      this.cdr.detectChanges();
    }
  }

  /**
   * It returns the background color of the entity type name.
   */
  getBackgroundColor(entityTypeName: string): string {
    const hash = this.getIdentifier(entityTypeName);
    const index = hash % this.backgroundColors.length;
    return this.backgroundColors[index];
  }

  /**
   * It returns the identifier of the entity type name.
   */
  getIdentifier(entityTypeName: string): number {
    return entityTypeName.charCodeAt(0) + entityTypeName.charCodeAt(1) + entityTypeName.charCodeAt(2);
  }

  /**
   * It streams an observable it contains the filelist.
   */
  get resourceList$(): Observable<any[]> {
    return this._resourceList$.asObservable();
  }

  /**
   * Navigate to resource detail page.
   */
  navigateToResource(resource: any) {
    this.router.navigate([resource?.data?.url + "/" + resource?.data?.id]);
  }
}
